import React, {Component} from 'react';

import "react-table/react-table.css";
import '../css/style.css';
import 'react-datepicker/dist/react-datepicker.css';
import Spinner from 'react-spinner-material';

import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import couterpart from 'counterpart';
import DatePicker from 'react-datepicker';
import { FaFilter, FaFolderPlus } from 'react-icons/fa';
import ReactTable from "react-table";
import "react-table/react-table.css";
import {MdDeleteForever, MdModeEdit} from 'react-icons/md';
import { Multiselect } from 'multiselect-react-dropdown';

import AuthenticationService from '../services/AuthenticationService';
import MaterialStockService from '../services/MaterialStockService';
import {IoIosPersonAdd, IoIosMusicalNotes, IoIosUnlock, IoIosWallet} from 'react-icons/io';

import { ICON_COLOR } from '../icon';
import WorkOrderUtil from '../utilities/WorkOrderUtil';
import MaterialService from '../services/MaterialService';
import ProfileXiService from '../services/ProfileXiService';
import MaterialList from './MaterialList';
import {MATERIAL_STOCK_STATUS_NEW, 
        MATERIAL_STOCK_STATUS_DELIVERED, 
        MATERIAL_STOCK_STATUS_EMPTY, 
        MATERIAL_STOCK_STATUS_CHANGING, 
        MATERIAL_STOCK_STATUS_IN_USED, 
        MATERIAL_STOCK_STATUS_DELETED, 
        MATERIAL_STOCK_STATUS_DELIVERING} from '../constants';

class MaterialStockTabSuper extends Component{
    constructor() {
        super();

        const numOfMonths = 1;
        let fromDate = new Date(new Date().getTime() - numOfMonths*30*24*60*60*1000);//1 month
        fromDate = WorkOrderUtil.convertToyyyyMMddhhmmString(fromDate);
        let toDate = new Date(new Date().getTime() + 24*60*60*1000*3);
        toDate = WorkOrderUtil.convertToyyyyMMddhhmmString(toDate);
        
        this.state = {
            spinnerVisible: false,
            selected: {},
            selectAll: 0,
            deliveringInfo: {},
            refreshMaterial: 0,
            columns : [
                {
                    Header: () => (<div style={{ textAlign:"left", fontWeight: "bold" }}> { couterpart.translate('material_stock_stt') } </div>),
                    accessor: '',
                    width: 50,
                    Cell: row =>(
                        <div style={{ padding: "10px"}}>{row.index + 1}</div>
                    )
                },{
                    id: "checkbox",
                    accessor: "",
                    Cell: ({ original }) => {
                    return (
                        <div style={{ textAlign: "center" }}>
                        <input
                        type="checkbox"
                        className="checkbox"
                        checked={this.state.selected[original.batchNoGroup] && this.state.selected[original.batchNoGroup].checked === true}
                        onChange={() => this.toggleRow(original)}
                        /></div>
                    );
                    },
                    Header: x => {
                    return (
                        <input
                        type="checkbox"
                        className="checkbox"
                        checked={this.state.selectAll === 1}
                        ref={input => {
                            if (input) {
                            input.indeterminate = this.state.selectAll === 2;
                            }
                        }}
                        onChange={() => this.toggleSelectAll()}
                        />
                    );
                    },
                    sortable: false,
                    width: 30                  
                },{
                    Header: () => (<div style={{ textAlign:"left", fontWeight: "bold" }}> { couterpart.translate('material_stock_batch_no') } </div>),
                    accessor: 'batchNoGroup',
                    width: 320,
                    Cell: row =>(
                        this.linkToDetails(row)
                    )                                                   
                },{           
                    Header: () => (<div style={{ textAlign:"left", fontWeight: "bold" }}> { couterpart.translate('material_stock_so_can') } </div>),
                    accessor: 'soCan',
                    filterable: false,
                    width: 80
                },{           
                    Header: () => (<div style={{ textAlign:"left", fontWeight: "bold" }}> { 'Số Lít' } </div>),
                    accessor: '',
                    filterable: false,
                    width: 70,
                    Cell: row =>(
                    <div style={{ textAlign: "center" }}>
                        {this.renderSolit(row)}
                    </div>
                    )                    
                },{
                    Header: () => (<div style={{ textAlign:"left", fontWeight: "bold" }}> { couterpart.translate('material_stock_seller') } </div>),
                    accessor: 'seller',
                    width: 150,
                    Cell: row =>(
                        <div style={{ textAlign: "center" }}>
                            &nbsp;
                        </div>
                    )
                },{
                    Header: () => (<div style={{ textAlign:"left", fontWeight: "bold" }}> { couterpart.translate('material_stock_status') } </div>),
                    accessor: 'status',
                    width: 120,
                    Cell: row =>(
                        <div style={{ textAlign: "center" }}>
                            &nbsp;
                        </div>
                    )
                },{
                    Header: () => (<div style={{ textAlign:"left", fontWeight: "bold" }}> { couterpart.translate('material_stock_created_at') } </div>),
                    accessor: 'createdAt',
                    width: 110,
                    Cell: row =>(
                        <div style={{ textAlign: "center" }}>
                            &nbsp;
                        </div>
                    )
                },{                                         
                    Header: couterpart.translate('material_stock_delete'),
                    accessor: '',
                    width: 100,
                    Cell: row =>(
                    <div style={{ textAlign: "center" }}>
                        {this.renderDeleteButton(row)}
                    </div>
                    )
                }                    
            ],
            subColumns: [
                {
                    Header: "",
                    accessor: "toggle",
                    width: 50
                },{
                    Header: "",
                    accessor: "toggle",
                    width: 80
                },{
                    Header: couterpart.translate('material_stock_batch_no'),
                    accessor: 'batchNo',
                    width: 390                                   
                },{
                    Header: couterpart.translate('material_stock_dung_tich'),
                    accessor: 'dungTich',
                    width: 70,
                    Cell: row =>(
                    <div style={{ textAlign: "center" }}>
                        { this.renderSubSolit(row) }
                    </div>
                    )
                },{
                    Header: () => (<div style={{ textAlign:"left", fontWeight: "bold" }}> { couterpart.translate('material_stock_seller') } </div>),
                    accessor: 'seller',
                    width: 150
                },{           
                    Header: couterpart.translate('material_stock_status'),
                    accessor: 'status',
                    filterable: false,
                    width: 120,
                    Cell: props => this.getStatusDescription(props.value)
                },{
                    Header: () => (<div style={{ textAlign:"left", fontWeight: "bold" }}> { couterpart.translate('material_stock_created_at') } </div>),
                    accessor: 'createdAt',
                    width: 110
                },{                                         
                    Header: couterpart.translate('material_stock_delete'),
                    accessor: '',
                    width: 100,
                    Cell: row =>(
                    <div style={{ textAlign: "center" }}>
                        {this.renderDeliverySelectionButton(row)}
                    </div>
                    )
                }
            ],
            // materialStocks: [],
            show: false,
            showNew: false,
            defaultSoCan: 2,
            defaultMappingQuantity: 200,
            defaultMappingCanCode: 'C2',
            defaultMappingCanCapacity: 2,
            defaultDungTich: 1,
            id: 0,
            remainQuantity: 0,
            soCan: 2,
            dungTich: 1,
            seller: '',
            batchNoOld: '',
            batchNo: '',
            batchNos: [],
            materialItems: [],
            canItems: [
                {code: 'C2', name: 'Cốc 2 lít', dungTich: 2 }
            ],
            xkItems: [],
            selectedCanCode: 'C2',
            statusList: [
                {
                    id: -1,
                    name: 'All'
                },
                {
                    id: MATERIAL_STOCK_STATUS_NEW,
                    name: 'Mới'
                },
                {
                    id: MATERIAL_STOCK_STATUS_DELIVERED,
                    name: 'Đã giao cho thợ'
                },  
                {
                    id: MATERIAL_STOCK_STATUS_CHANGING,
                    name: 'Đang thay cốc'
                },                              
                {
                    id: MATERIAL_STOCK_STATUS_IN_USED,
                    name: 'Đang sử dụng'
                },                
                {
                    id: MATERIAL_STOCK_STATUS_EMPTY,
                    name: 'Sử dụng hết'
                },
                {
                    id: MATERIAL_STOCK_STATUS_DELETED,
                    name: 'Hết sủ dụng'
                }
            ],
            fromDate: fromDate,
            toDate: toDate,            
            selectedCode: '',
            stockDate: '',
            searchCode: '',
            searchSeller: '',
            searchStatus: 0,
            selectedPage: 0,
            pageSize: 10,
            loading: false,
            showHistory: false,
            historyColumns : [
                {
                    Header: () => (<div style={{ textAlign:"left", fontWeight: "bold" }}> { couterpart.translate('material_history_stt') } </div>),
                    accessor: '',
                    width: 70,
                    Cell: row =>(
                        <div style={{ padding: "10px"}}>{row.index + 1}</div>
                    )
                },{
                    Header: () => (<div style={{ textAlign:"left", fontWeight: "bold" }}> { couterpart.translate('material_history_batch_no') } </div>),
                    accessor: 'batchNo',
                    width: 500                     
                },{
                    Header: () => (<div style={{ textAlign:"left", fontWeight: "bold" }}> { couterpart.translate('material_history_batch_no_new') } </div>),
                    accessor: 'newBatchNo',
                    width: 500                                                   
                },{           
                    Header: () => (<div style={{ textAlign:"left", fontWeight: "bold" }}> { couterpart.translate('material_history_quantity') } </div>),
                    accessor: 'quantity',
                    filterable: false,
                    width: 100
                },{
                    Header: () => (<div style={{ textAlign:"left", fontWeight: "bold" }}> { couterpart.translate('material_history_remain_quantity') } </div>),
                    accessor: 'remainQuantity',
                    width: 100
                },{
                    Header: () => (<div style={{ textAlign:"left", fontWeight: "bold" }}> { couterpart.translate('material_history_modified_by') } </div>),
                    accessor: 'modifiedBy',
                    width: 150,
                    Cell: props => this.getStatusDescription(props.value)
                },{
                    Header: () => (<div style={{ textAlign:"left", fontWeight: "bold" }}> { couterpart.translate('material_history_modified_at') } </div>),
                    accessor: 'modifiedAt'
                }                   
            ],
            materialHistories: [],
            historyFromDate: fromDate,
            historyToDate: toDate,            
            searchMaterial: '',
            searchModifiedBy: '',
            searchStatus: 0,
            selectedHistoryPage: 0,
            historyPageSize: 20,
            historyLoading: false,
            showInventory: false,
            inventoryColumns: [
                {
                    Header: () => (<div style={{ textAlign:"left", fontWeight: "bold" }}> { couterpart.translate('inventory_stt') } </div>),
                    accessor: '',
                    width: 70,
                    Cell: row =>(
                        <div style={{ padding: "10px"}}>{row.index + 1}</div>
                    )
                },{
                    Header: () => (<div style={{ textAlign:"left", fontWeight: "bold" }}> { couterpart.translate('inventory_code') } </div>),
                    accessor: 'code',
                    width: 300                     
                },{
                    Header: () => (<div style={{ textAlign:"left", fontWeight: "bold" }}> { couterpart.translate('inventory_available') } </div>),
                    accessor: 'newInventory',
                    width: 120                                                   
                },{           
                    Header: () => (<div style={{ textAlign:"left", fontWeight: "bold" }}> { couterpart.translate('inventory_used') } </div>),
                    accessor: 'usedInventory',
                    filterable: false,
                    width: 100
                },{           
                    Header: () => (<div style={{ textAlign:"left", fontWeight: "bold" }}> { couterpart.translate('inventory_usable') } </div>),
                    accessor: '',
                    filterable: false,
                    width: 100,
                    Cell: row =>(
                    <div style={{ textAlign: "center" }}>
                        { row.original.newInventory - row.original.usedInventory >= 0? row.original.newInventory - row.original.usedInventory : 0 }
                    </div>
                    )
                }
            ],
            inventoryInfo: [],
            mappingCanCode: '',
            mappingCanCapacity: 2,
            mappingQuantity: 200,
            mappingMaterial: {},
            profileXiFromDate: fromDate,
            profileXiToDate: toDate,             
            selectedProfileXiPage: 0,
            profileXiPageSize: 10,
            profileXiLoading: false,
            showProfileXis: false,
            showAddProfileXi: false,
            profileXiColumns: [
                {
                    Header: () => (<div style={{ textAlign:"left", fontWeight: "bold" }}> { couterpart.translate('profile_xi_stt') } </div>),
                    accessor: '',
                    width: 70,
                    Cell: row =>(
                        <div style={{ padding: "10px"}}>{row.index + 1}</div>
                    )
                },{
                    Header: () => (<div style={{ textAlign:"left", fontWeight: "bold" }}> { couterpart.translate('profile_xi_ten') } </div>),
                    accessor: 'ten',
                    width: 200                     
                },{
                    Header: () => (<div style={{ textAlign:"left", fontWeight: "bold" }}> { couterpart.translate('profile_xi_vol') } </div>),
                    accessor: 'vol',
                    width: 200                                                   
                },{           
                    Header: () => (<div style={{ textAlign:"left", fontWeight: "bold" }}> { couterpart.translate('profile_xi_nhietdo') } </div>),
                    accessor: 'nhietDo',
                    filterable: false,
                    width: 100
                },{           
                    Header: () => (<div style={{ textAlign:"left", fontWeight: "bold" }}> { couterpart.translate('profile_xi_thoigian') } </div>),
                    accessor: 'thoiGian',
                    filterable: false,
                    width: 100
                },{           
                    Header: () => (<div style={{ textAlign:"left", fontWeight: "bold" }}> { couterpart.translate('profile_xi_ph') } </div>),
                    accessor: 'ph',
                    filterable: false,
                    width: 100
                },{           
                    Header: () => (<div style={{ textAlign:"left", fontWeight: "bold" }}> { couterpart.translate('profile_xi_tytrong') } </div>),
                    accessor: 'tyTrong',
                    filterable: false,
                    width: 100
                },{           
                    Header: () => (<div style={{ textAlign:"left", fontWeight: "bold" }}> { couterpart.translate('profile_xi_updateat') } </div>),
                    accessor: 'updatedAt',
                    filterable: false,
                    width: 200
                },{           
                    Header: () => (<div style={{ textAlign:"left", fontWeight: "bold" }}> { couterpart.translate('profile_xi_note') } </div>),
                    accessor: 'note',
                    filterable: false,
                    width: 200
                },{           
                    Header: () => (<div style={{ textAlign:"left", fontWeight: "bold" }}> { couterpart.translate('profile_xi_group') } </div>),
                    accessor: 'groupName',
                    filterable: false,
                    width: 200                                        
                },{
                    Header: () => (<div style={{ textAlign:"left", fontWeight: "bold" }}>&nbsp;</div>),
                    accessor: 'action',
                    width: 150,
                    Cell: row =>(
                        this.getFunctionButtons(row)
                    )
                }
            ],
            idProfileXi:  0,
            tenProfileXi: '',
            volProfileXi: '',
            nhietDoProfileXi: '',
            thoiGianProfileXi: '',
            phProfileXi: '',
            tyTrongProfileXi: '',
            groupNameProfileXi: '',
            noteProfileXi: '',
            profileXis: [],
            showMappingProfile: false,
            profileXiItems: [],
        };
    };

    loadMaterialItems(){
        MaterialStockService.retrieveMaterialItems().then(data =>{
            //console.log('MATERIAL ITEMS', data)
            this.setState({ 
                materialItems: data
            });
        });
    }

    loadProfileXiItems(){
        ProfileXiService.fetchAllProfileXis().then(data =>{
            //console.log('PROFILE XI ITEMS', data)
            this.setState({ 
                profileXiItems: data
            });
        });
    }

    fetchMaterialMappingBy(){
        MaterialStockService.fetchMaterialMappingBy(this.state.selectedMappingCode).then(data =>{
            //console.log('MATERIAL MAPPING', data)
            this.setState({ 
                mappingCanCode: data.canCode,
                mappingCanCapacity: data.canCapacity,
                mappingQuantity: data.quantity,
                mappingMaterial: data
            });
        });
    }

    getFunctionButtons(row){
        if (AuthenticationService.isAdmin()){
            const button_edit = couterpart.translate('button_edit');
            const button_delete = couterpart.translate('button_delete');
            return (
            <div style={{ textAlign: "center" }}>
            <button className="myButton" onClick={() => this.handleEditProfile(row.original)}>
            <MdModeEdit color={ICON_COLOR}/>&nbsp;
            {button_edit}</button>&nbsp;
            <button className="myButton" onClick={() => this.handleDeleteProfile(row.original)}>
            <MdDeleteForever color={ICON_COLOR}/>&nbsp;
            {button_delete}</button>
            </div>
            )
      }else{
            return (<div>&nbsp;</div>)
      }
    }

    handleEditProfile(item){
        this.loadProfileXiForm(item);
        this.handleViewAddProfileXi();
    }
    
    handleDeleteProfile(item){
        let ret = window.confirm(couterpart.translate('msg_delete_profile_xi_confirm'));
        if (ret === true){
            ProfileXiService.deleteProfileXi(item.id).then(data => {
                if (data > 0){
                    alert("Profile xi đã được xóa.");
                    this.filterProfileXiBy();
                } else {
                    alert("Lỗi. Không thể xóa thông tin profile xi.");
                }
            });
        }
    }

    toggleRow(row) {
        let newSelected = Object.assign({}, this.state.selected);
        if (newSelected[row.batchNoGroup] === undefined){
            newSelected[row.batchNoGroup] = {checked: true, batchNoGroup: row.batchNoGroup};
        }

        if (this.state.selected[row.batchNoGroup]){
            newSelected[row.batchNoGroup].checked = !this.state.selected[row.batchNoGroup].checked;
            newSelected[row.batchNoGroup].batchNoGroup = this.state.selected[row.batchNoGroup].batchNoGroup;
        }

        this.setState({
            selected: newSelected,
            selectAll: 2
        }, () =>{
            WorkOrderUtil.saveItem('materialStock.selected', JSON.stringify(this.state.selected));
        });
	}

	toggleSelectAll() {
		const newSelected = Object.assign({}, this.state.selected);
		if (this.state.selectAll === 0 || this.state.selectAll === undefined) {
			this.state.dataGroup.forEach(x => {
                if (newSelected[x.batchNoGroup] === undefined){
                    newSelected[x.batchNoGroup] = {checked: true, batchNoGroup: x.batchNoGroup};
                } else {        
                    newSelected[x.batchNoGroup].checked = true;
                    newSelected[x.batchNoGroup].batchNoGroup = x.batchNoGroup;
                }
            });
        } else {
            this.state.dataGroup.forEach(x => {
                if (newSelected[x.batchNoGroup] === undefined){
                    newSelected[x.batchNoGroup] = {checked: false, batchNoGroup: x.batchNoGroup};
                } else {        
                    newSelected[x.batchNoGroup].checked = false;
                    newSelected[x.batchNoGroup].batchNoGroup = x.batchNoGroup;
                }
		    });
        }

		this.setState({
            selected: newSelected,
            selectAll: this.state.selectAll === 0 ? 1 : 0
		}, () =>{
            WorkOrderUtil.saveItem('materialStock.selected', JSON.stringify(this.state.selected));
        });
	}

    componentDidMount () {
        this.loadMaterialItems();
        this.loadProfileXiItems();
        this.onFilter();  
    }

    filterBy(){
        if ((this.state.selectedPage < 0) || (this.state.pageSize < 0)){
        return;
        }

        this.setState({ loading: true });
        let page = this.state.selectedPage === undefined? 0: this.state.selectedPage;
        let pageSize = this.state.pageSize === undefined? 10: this.state.pageSize;   

        MaterialStockService.fetchMaterialStocks(page, pageSize, this.state.fromDate, this.state.toDate, this.state.searchCode, this.state.searchSeller, this.state.selectedWoStatusList, 1)
        .then(dataGroup => { 
            if(dataGroup !== undefined && dataGroup.message === undefined &&  dataGroup.materialStocks instanceof Array){
                let group = {};
                for(let i=0; i<dataGroup.materialStocks.length; i++){
                    let batchNoGroup = dataGroup.materialStocks[i].batchNoGroup;
                    MaterialStockService.fetchMaterialStockByBatchNoGroup(batchNoGroup).then(dataOfGroup => {
                        if(dataOfGroup !== undefined && dataOfGroup.message === undefined){
                            group[batchNoGroup] = dataOfGroup;
                        }
                    })
                }
                this.setState({ dataGroup: dataGroup.materialStocks, group: group, spinnerVisible: false, loading: false, pages: dataGroup.totalPages, page: dataGroup.currentPage, pageSize: pageSize});
            }else{
                this.setState({ dataGroup: [], group: {}, loading: false, pages: 0, page: 0, pageSize: pageSize});
            }   
        });
    }

    filterHistoriesBy(){
        if ((this.state.selectedHistoryPage < 0) || (this.state.historyPageSize < 0)){
        return;
        }

        this.setState({ historyLoading: true });
        let historyPage = this.state.selectedHistoryPage === undefined? 0: this.state.selectedHistoryPage;
        let historyPageSize = this.state.historyPageSize === undefined? 10: this.state.historyPageSize;   

        MaterialService.fetchMaterialStocks(historyPage, historyPageSize, this.state.historyFromDate, this.state.historyToDate, this.state.searchMaterial, this.state.searchModifiedBy)
        .then(data => { 
            if(data.message === undefined && data !== undefined &&  data.materialHistories instanceof Array){
                //console.log(data.materialHistories);
                this.setState({ materialHistories: data.materialHistories, spinnerVisible: false, historyLoading: false, historyPages: data.totalPages, historyPage: data.currentPage, historyPageSize: historyPageSize});
            }else{
                this.setState({ materialHistories:  [], historyLoading: false, historyPages: 0, historyPage: 0, historyPageSize: historyPageSize});
            }   
        });
    }

    filterProfileXiBy(){
        if ((this.state.selectedProfileXiPage < 0) || (this.state.selectedProfileXiPage < 0)){
            return;
        }

        this.setState({ profileXiLoading: true });
        let profileXiPage = this.state.selectedProfileXiPage === undefined? 0: this.state.selectedProfileXiPage;
        let profileXiPageSize = this.state.profileXiPageSize === undefined? 10: this.state.profileXiPageSize;   

        ProfileXiService.fetchProfileXiBy(profileXiPage, profileXiPageSize, this.state.profileXiFromDate, this.state.profileXiToDate)
        .then(data => { 
            if(data.message === undefined && data !== undefined &&  data.profileXis instanceof Array){
                //console.log(data.profileXis);
                this.setState({ profileXis: data.profileXis, spinnerVisible: false, profileXiLoading: false, profileXiPages: data.totalPages, profileXiPage: data.currentPage, profileXiPageSize: profileXiPageSize});
            }else{
                this.setState({ profileXis:  [], profileXiLoading: false, profileXiPages: 0, profileXiPage: 0, profileXiPageSize: profileXiPageSize});
            }   
        });
    }

    getStatusDescription(status){
        if (status === MATERIAL_STOCK_STATUS_NEW) {
            return 'Mới';
        }

        if (status === MATERIAL_STOCK_STATUS_DELIVERED) {
            return 'Đã giao cho thợ';
        }

        if (status === MATERIAL_STOCK_STATUS_CHANGING) {
            return 'Đang thay cốc';
        }

        if (status === MATERIAL_STOCK_STATUS_IN_USED) {
            return 'Đang sử dụng';
        }                
        
        if (status === MATERIAL_STOCK_STATUS_EMPTY) {
            return 'Sử dụng hết';
        }

        if (status === MATERIAL_STOCK_STATUS_DELETED) {
            return 'Hết sủ dụng';
        }
        return status + '';
    }

    linkToDetails(row){
        return(
            <label className="label_link" href="#!" onClick={() => {this.handleEdit(row.original)}}>{row.original.batchNoGroup}</label>
        )
    }

    renderDeleteButton(row){
        if (row.original.status !== MATERIAL_STOCK_STATUS_NEW){
            return (<></>);
        }

        const button_delete = couterpart.translate('button_delete');

        if (AuthenticationService.isAdmin()){
            return (<div>
                    <button className="btn-primary-r" onClick={() => this.handleDelete(row.original)}>
                    <MdDeleteForever color={ICON_COLOR}/>
                    &nbsp;{button_delete}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</button>
                        </div>
                    );
        }else{
            return (<></>);
        }
    }

    renderSolit(row){
        return (
            <div>
                { row.original.dungTich * row.original.soCan }
            </div>
        )
    }

    renderSubSolit(row){
        return (
            <div>
                { row.original.dungTich }
            </div>
        )
    }

    renderDeliverySelectionButton(row){
        if (row.original.status !== MATERIAL_STOCK_STATUS_NEW){
            return (<></>);
        }
        if (AuthenticationService.isAdmin()){
            if (this.isSelectedToDelivery(row.original)){
                return (<></>);
            }

            return (<div>
                    <button className="btn-primary-y" onClick={() => this.handleDeliverySelection(row.original)}>
                    <MdModeEdit color={ICON_COLOR}/>
                    &nbsp;{couterpart.translate('button_xuat')}</button>
                        </div>
                    );
        }else{
            return (<></>);
        }
    }

    renderMaterialItemList(){
        if (this.state.materialItems === undefined || this.state.materialItems === null){
            return (<></>);
        }
        return(
            <select onChange={this.handleMaterialItemChange.bind(this)} value={ this.state.selectedMaterialCode } defaultValue={ this.state.code }>
                <option value="UNKNOWN" key="UNKNOWN"></option>
                { this.state.materialItems.map(x => <option value={x.code} key={x.code} defaultValue="UNKNOWN">{x.name}</option>)}
            </select>
        );
    }

    renderMappingMaterialItemList(){
        if (this.state.materialItems === undefined || this.state.materialItems === null){
            return (<></>);
        }
        return(
            <select onChange={this.handleMappingMaterialItemChange.bind(this)} value={ this.state.selectedMappingCode } >
                <option value="UNKNOWN" key="UNKNOWN"></option>
                { this.state.materialItems.map(x => <option value={x.code} key={x.code} defaultValue="UNKNOWN">{x.name}</option>)}
            </select>
        );
    }

    renderMappingMaterialProfileItemList(){
        if (this.state.materialItems === undefined || this.state.materialItems === null){
            return (<></>);
        }
        return(
            <select onChange={this.handleMappingMaterialProfileItemChange.bind(this)} value={ this.state.selectedMappingMaterialId } >
                <option value="0" key="0"></option>
                { this.state.materialItems.map(x => <option value={x.id} key={x.id} defaultValue="0">{x.name}</option>)}
            </select>
        );
    }

    renderMappingProfileXiItemList(){
        if (this.state.profileXiItems === undefined || this.state.profileXiItems === null){
            return (<></>);
        }
        return(
            <select onChange={this.handleMappingProfileXiItemChange.bind(this)} value={ this.state.selectedMappingProfileXiId } >
                <option value="0" key="0"></option>
                { this.state.profileXiItems.map(x => <option value={x.id} key={x.id} defaultValue="0">{x.ten}</option>)}
            </select>
        );
    }    

    renderCanItems(){
        if (this.state.canItems === undefined || this.state.canItems === null){
            return (<></>);
        }
        return(
            <select onChange={this.handleCanItemChange.bind(this)} value={ this.state.selectedCanCode } defaultValue={ this.state.canCode }>
                {/* <option value="UNKNOWN" key="UNKNOWN"></option> */}
                { this.state.canItems.map(x => <option value={x.code} key={x.code}>{x.name}</option>)}
            </select>
        );
    }

    renderXuatKhoItems(){
        if (this.state.xkItems === undefined || this.state.xkItems === null || this.state.xkItems.length < 1){
            return (
            <table border = "1px" width="100%">
                <thead>
                    <tr>
                        <th>Batch No</th>
                        <th>Số lượng</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                    </tr>
                </tbody>
            </table>
            );
        }
        return(
            <table border = "1px" width="100%">
                <thead>
                    <tr>
                        <th>Batch No</th>
                        <th>Số lượng</th>
                        <th>&nbsp;</th>
                    </tr>
                </thead>
                <tbody>
                    { this.state.xkItems.map(x => 
                        <tr key={x.batchNo}>
                            <td>{ x.batchNo }</td>
                            <td>{ x.dungTich }</td>
                            <td>
                                <button name="bochon" className="myButton" onClick={this.handleUnSelect.bind(this, x.id)} style={{ marginLeft: "20px"}}><IoIosUnlock color={ICON_COLOR}/>&nbsp;Hủy chọn</button>
                            </td>
                        </tr>
                        )
                    }
                </tbody>
            </table>
        );
    }

    handleUnSelect(id){
        let deliveringInfo = this.state.deliveringInfo;
        deliveringInfo['' + id] = 0
        let xkItems = this.state.xkItems.filter(it => {
            return it.id !== id;
        });
        this.setState({
            deliveringInfo: deliveringInfo,
            xkItems: xkItems
        });

    }

    renderMaterialList() {
        if (this.state.dataGroup === undefined || this.state.dataGroup === null || !(this.state.dataGroup instanceof Array)){
            return (<></>);
        }

        return (
            <div className="row">
                <div className="col-12">
                    <div className="row">
                        <div className="col-12">
                        <ReactTable
                            manual
                            NoDataComponent={() => null} 
                            previousText={"<"}
                            nextText={">"}
                            onPageChange={pageIndex => {
                            this.setState({ selectedPage: pageIndex }, () => {
                                this.filterBy()
                            })
                            }}
                            onPageSizeChange={(pageSize, pageIndex) => {
                            this.setState({ selectedPage: pageIndex, pageSize: pageSize }, () => {
                                this.filterBy()
                            });
                            }}
                            className="-striped -highlight"                             
                            data={this.state.dataGroup}
                            loading= { this.state.loading }  
                            pages={ this.state.pages }
                            columns={this.state.columns}
                            defaultPageSize = {10}
                            showPageSizeOptions = {true}
                            pageSizeOptions = {[3, 5, 10, 20]}
                            SubComponent={row => {
                            let items = this.state.group[row.original.batchNoGroup];
                            return (
                                <ReactTable
                                data={items}
                                columns={this.state.subColumns}
                                TheadComponent={() => null}
                                defaultPageSize={items.length}
                                showPagination={false}
                                />
                            );
                            }}
                        />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderMaterialHistoryList() {
        if (this.state.materialHistories === undefined || this.state.materialHistories === null || !(this.state.materialHistories instanceof Array)){
            return (<></>);
        }

        return (
            <div className="row">
                <div className="col-12">
                  <ReactTable
                    manual
                    NoDataComponent={() => null} 
                    previousText={"<"}
                    nextText={">"}
                    onPageChange={pageIndex => {
                      this.setState({ selectedHistoryPage: pageIndex }, () => {
                        this.filterHistoriesBy()
                      })
                    }}
                    onPageSizeChange={(pageSize, pageIndex) => {
                      this.setState({ selectedHistoryPage: pageIndex, historyPageSize: pageSize }, () => {
                        this.filterHistoriesBy()
                      });
                    }}
                    className="-striped -highlight"                             
                    data={this.state.materialHistories}
                    loading= { this.state.historyLoading }  
                    pages={ this.state.historyPages }
                    columns={this.state.historyColumns}
                    defaultPageSize = {this.state.historyPageSize}
                    showPageSizeOptions = {true}
                    pageSizeOptions = {[2, 5, 10, 20]}
                  />
                </div>
            </div>
        );
    }

    renderProfileXiList() {
        if (this.state.profileXis === undefined || this.state.profileXis === null || !(this.state.profileXis instanceof Array)){
            return (<></>);
        }

        return (
            <div className="row">
                <div className="col-12">
                  <ReactTable
                    manual
                    NoDataComponent={() => null} 
                    previousText={"<"}
                    nextText={">"}
                    onPageChange={pageIndex => {
                      this.setState({ selectedProfileXiPage: pageIndex }, () => {
                        this.filterProfileXiBy()
                      })
                    }}
                    onPageSizeChange={(pageSize, pageIndex) => {
                      this.setState({ selectedProfileXiPage: pageIndex, profileXiPageSize: pageSize }, () => {
                        this.filterProfileXiBy()
                      });
                    }}
                    className="-striped -highlight"                             
                    data={this.state.profileXis}
                    loading= { this.state.profileXiLoading }  
                    pages={ this.state.profileXiPages }
                    columns={this.state.profileXiColumns}
                    defaultPageSize = {this.state.profileXiPageSize}
                    showPageSizeOptions = {true}
                    pageSizeOptions = {[2, 5, 10, 20]}
                  />
                </div>
            </div>
        );
    }    

    renderInventory(){
        if (this.state.inventoryInfo === undefined || this.state.inventoryInfo === null || !(this.state.inventoryInfo instanceof Array)){
            return (<></>);
        }

        return (
            <div className="row">
                <div className="col-12">
                  <ReactTable
                    manual
                    NoDataComponent={() => null} 
                    previousText={"<"}
                    nextText={">"}
                    className="-striped -highlight"                             
                    data={this.state.inventoryInfo} 
                    pages={ 1 }
                    columns={this.state.inventoryColumns}
                    defaultPageSize = {10}
                    showPageSizeOptions = {false}
                    pageSizeOptions = {[10]}
                    showPagination={false}
                  />
                </div>
            </div>
        );
    }

    handleMaterialItemChange(e){
        let value = e.target[e.target.selectedIndex].value;
        this.setState({                 
            selectedCode: value                   
        }, () => {
            this.generatebatchNo();
        });
    }

    handleMappingMaterialItemChange(e){
        let value = e.target[e.target.selectedIndex].value;
        this.setState({                 
            selectedMappingCode: value                   
        }, () => {
            this.fetchMaterialMappingBy(); 
        });
    } 

    handleMappingMaterialProfileItemChange(e){
        let value = e.target[e.target.selectedIndex].value;
        this.setState({                 
            selectedMappingMaterialId: value                   
        }, () => {
            //this.fetchMaterialMappingBy(); 
        });
    }

    handleMappingProfileXiItemChange(e){
        let value = e.target[e.target.selectedIndex].value;
        this.setState({                 
            selectedMappingProfileXiId: value                   
        }, () => {
            //this.fetchMaterialMappingBy(); 
        });
    }

    handleCanItemChange(e){
        let value = e.target[e.target.selectedIndex].value;
        this.setState({                 
            selectedCanCode: value,
            xkItems: []                   
        });
    }

    handleSoCanChange(e){
        var value = e.target.value;
        this.setState({                 
            soCan: value                   
        }, () => {
            this.generatebatchNo();
        });
    }

    handleDungTichChange(e){
        var value = e.target.value;
        this.setState({                 
            dungTich: value                   
        }, () => {
            this.generatebatchNo();
        });
    }

    handleSellerChange(e){
        let value = e.target.value;
        this.setState({                 
            seller: value                   
        }, () => {
            this.generatebatchNo();
        });
    }

    handleMappingQuantityChange(e){
        var value = e.target.value;
        this.setState({                 
            mappingQuantity: value                   
        });
    }

    handleMappingCanCodeChange(e){
        var value = e.target.value;
        this.setState({                 
            mappingCanCode: value                   
        });
    }

    handleMappingCanCapacityChange(e){
        var value = e.target.value;
        this.setState({                 
            mappingCanCapacity: value                   
        });
    }

    handleTenProfileXiChange(e){
        var value = e.target.value;
        this.setState({                 
            tenProfileXi: value                   
        });
    }

    handleVolProfileXiChange(e){
        var value = e.target.value;
        this.setState({                 
            volProfileXi: value                   
        });
    }

    handleNhietDoProfileXiChange(e){
        var value = e.target.value;
        this.setState({                 
            nhietDoProfileXi: value                   
        });
    }

    handleThoiGianProfileXiChange(e){
        var value = e.target.value;
        this.setState({                 
            thoiGianProfileXi: value                   
        });
    }                

    handlePhProfileXiChange(e){
        var value = e.target.value;
        this.setState({                 
            phProfileXi: value                   
        });
    } 

    handleTyTrongProfileXiChange(e){
        var value = e.target.value;
        this.setState({                 
            tyTrongProfileXi: value                   
        });
    }

    handleGroupNameProfileXiChange(e){
        var value = e.target.value;
        this.setState({                 
            groupNameProfileXi: value                   
        });
    }     

    handleNoteProfileXiChange(e){
        var value = e.target.value;
        this.setState({                 
            noteProfileXi: value                   
        });
    }

    generatebatchNo(){
        let stockDate = this.state.stockDate.substring(0,10);
        stockDate = stockDate.replace("/", "");
        stockDate = stockDate.replace("/", "");
        let batchNo = this.state.selectedCode + "_" + stockDate + "_" + this.state.seller;

        let soCan = this.state.soCan;
        let batchNos = [];
        for(let i=1; i<=soCan; i++){
            batchNos.push(batchNo + "_can_" + i);
        }
        this.setState({                 
            batchNo: batchNo,
            batchNos: batchNos                   
        });
    }

    handleEdit(item){
        this.setState({ show: true, soCan: item.soCan, dungTich: item.dungTich, id: item.id, batchNo: item.batchNoGroup, code: item.code, selectedCode: item.code, stockDate: item.stockDate, seller: item.seller, batchNoGroupInit: item.batchNoGroup });
    }

    handleNew(){
        this.setState({ showNew: true, soCan: '', id: 0, batchNo: '', code: '', seller: '', batchNo: '', batchNos: [], dungTich: ''});
    }

    handleViewHistory(){
        this.setState({ showHistory: true}, () => {
            this.filterHistoriesBy();
        });
    }

    handleMapping(){
        this.setState({ showMapping: true, mappingCanCapacity: '', id: 0, mappingCanCode: '', mappingQuantity: '', mappingMaterial: {}, selectedMappingCode: 'UNKNOWN' });
    }

    handleMappingProfile(){
        this.setState({ showMappingProfile: true, mappingProfileXiMaterial: {}, selectedMappingMaterialId: 0, selectedMappingProfileXiCode: 0 }, () => {
            this.loadProfileXiItems();
        });
    }

    handleViewProfileXi(){
        this.setState({ showProfileXis: true}, () => {
            this.filterProfileXiBy();
        });
    }

    handleViewAddProfileXi(){
        this.setState({ showAddProfileXi: true}, () => {
            
        });
    }    

    handleExport(){
        // console.log(this.state.selected);
        let selectedBatchNoGroups = [];
        if ((this.state.selected !== undefined) && (this.state.selected !== null)) {
            for (let key in this.state.selected) {
                if (this.state.selected[key].checked === true){
                    selectedBatchNoGroups.push(key);
                }
            }
        }
        MaterialStockService.exportMaterialStocks(selectedBatchNoGroups).then(data =>{
            this.setState({selected: {}}, () => {
                this.filterBy();
            });

            const downloadUrl = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement('a');
            link.href = downloadUrl;
            let m = new Date();
            let dateString =
                m.getUTCFullYear() + "" +
                ("0" + (m.getUTCMonth()+1)).slice(-2) + "" +
                ("0" + m.getUTCDate()).slice(-2) + "_" +
                ("0" + m.getUTCHours()).slice(-2) + "" +
                ("0" + m.getUTCMinutes()).slice(-2) + "" +
                ("0" + m.getUTCSeconds()).slice(-2);
            link.setAttribute('download', "material-stocks" + dateString + ".xlsx");
            document.body.appendChild(link);
            link.click();
            link.remove();
            this.sleep(100).then(() => {this.setState({spinnerVisible: false});});  
            this.setState({selected: {} });  
        });
    }

    handleInventory(){
        MaterialStockService.fetchInventory(undefined, undefined).then(data =>{
            this.setState({ showInventory: true, inventoryInfo: data});  
        });
    }

    handleClose(){
        this.setState({ show: false });
    }

    handleCloseNew(){
        this.setState({ showNew: false });
    }

    handleCloseMapping(){
        this.setState({ showMapping: false });
    }

    handleCloseMappingProfile(){
        this.setState({ 
            showMappingProfile: false,
            selectedMappingMaterialId: 0,
            selectedMappingProfileXiId: 0  
        });
    }

    applyMapping(){
        if (this.state.mappingQuantity <= 0){
            alert('Xin nhập số lượng');
            return 
        }

        if (this.state.mappingCanCode === null || this.state.mappingCanCode === undefined || this.state.mappingCanCode.trim().length < 1){
            alert('Xin nhập mã cốc');
            return 
        }        

        if (this.state.mappingCanCapacity <= 0){
            alert('Xin nhập dung tích cốc');
            return 
        }

        let mapping = {
            quantity: this.state.mappingQuantity,
            canCode: this.state.mappingCanCode,
            canCapacity: this.state.mappingCanCapacity,
            id: this.state.mappingMaterial.id,
            capacity: this.state.mappingMaterial.capacity,
            code: this.state.mappingMaterial.code
        }

        MaterialStockService.updateMaterialMapping(mapping).then(data => {
            if (data === 1){
                alert("Thông tin cài đặt nguyên liệu đã được lưu.");
            } else {
                alert("Lỗi. Thông tin cài đặt nguyên liệu chưa được lưu.");
            }
        });
    }

    applyMappingProfile(){
        let  material = {
            id: this.state.selectedMappingMaterialId,
            profileXiId: this.state.selectedMappingProfileXiId 
        };

        MaterialService.updateProfileXi(material).then(data => {
            this.setState({
                selectedMappingMaterialId: 0,
                selectedMappingProfileXiId: 0,
                refreshMaterial: this.state.refreshMaterial + 1 
            });
            if (data > 0){
                alert("Thông tin cài đặt profile xi của nguyên liệu đã được lưu.");
            } else {
                alert("Lỗi. Thông tin cài đặt profile xi của nguyên liệu chưa được lưu.");
            }
        });
    }

    isNullOrEmpty(vl){
        if (vl === null || vl === undefined || vl.trim().length < 1){
            return true;
        }
        return false;
    }

    saveProfileXi(){
        if (this.isNullOrEmpty(this.state.tenProfileXi)){
            alert('Xin nhập tên profile');
            return 
        }

        let profileXi = {
            id: this.state.idProfileXi,
            ten: this.state.tenProfileXi.trim(),
            vol: this.state.volProfileXi,
            nhietDo: this.state.nhietDoProfileXi,
            thoiGian: this.state.thoiGianProfileXi,
            ph: this.state.phProfileXi,
            tyTrong: this.state.tyTrongProfileXi,
            groupName: this.state.groupNameProfileXi,
            note: this.state.noteProfileXi,
        }

        if (profileXi.id !== null && profileXi.id !== undefined && profileXi.id > 0){
            ProfileXiService.updateProfileXi(profileXi).then(data => {
                if (data > 0){
                    alert("Thông tin profile xi đã được lưu.");
                    this.resetProfileXiForm();
                    this.filterProfileXiBy();
                } else {
                    alert("Lỗi. Thông tin profile xi chưa được lưu.");
                }
            });
        } else {
            ProfileXiService.createProfileXi(profileXi).then(data => {
                if (data > 0){
                    alert("Thông tin profile xi đã được lưu.");
                    this.resetProfileXiForm();
                    this.filterProfileXiBy();
                } else {
                    alert("Lỗi. Thông tin profile xi chưa được lưu.");
                }
            });
        }
    }

    loadProfileXiForm(p){
        this.setState({
            idProfileXi: p.id,
            tenProfileXi: p.ten,
            volProfileXi: p.vol,
            nhietDoProfileXi: p.nhietDo,
            thoiGianProfileXi: p.thoiGian,
            phProfileXi: p.ph,
            tyTrongProfileXi: p.tyTrong,
            groupNameProfileXi: p.groupName,
            noteProfileXi: p.note,
        });
    }

    resetProfileXiForm(){
        this.setState({
            idProfileXi: 0,
            tenProfileXi: '',
            volProfileXi: '',
            nhietDoProfileXi: '',
            thoiGianProfileXi: '',
            phProfileXi: '',
            tyTrongProfileXi: '',
            groupNameProfileXi: '',
            noteProfileXi: '',
        });
    }

    saveAndCloseMapping(){
        this.applyMapping();
        this.setState({
            showMapping: false
        });
    }

    saveAndCloseMappingProfile(){
        this.applyMappingProfile();
        this.setState({
            showMappingProfile: false
        });
    }

    handleCloseHistories(){
        this.setState({ showHistory: false });
    }

    handleCloseInventory(){
        this.setState({ showInventory: false });
    }

    handleCloseProfileXis(){
        this.setState({ showProfileXis: false });
    }

    handleCloseAddProfileXis(){
        this.setState({ showAddProfileXi: false });
    }

    saveAndCloseAddProfileXis(){
        this.saveProfileXi();
        this.handleCloseAddProfileXis();
    }        

    saveInfo(){
        if (this.allLetter(this.state.seller) === false){
            alert("Tên người bán không hợp lệ");
            return;
        }

        this.setState({ show: false });
        MaterialStockService.updateMaterialStock({id: this.state.id, soCan: this.state.soCan, dungTich: this.state.dungTich, batchNoGroup: this.state.batchNo, selectedCode: this.state.selectedCode, stockDate: this.state.stockDate, seller: this.state.seller, batchNoGroupInit: this.state.batchNoGroupInit }).then(() => {
            this.onFilter()
        });
    }

    allLetter(inputtxt){
        if (inputtxt === null || inputtxt === undefined){
            return false;
        }
        let letters = /^[A-Za-z]+$/;
        if(inputtxt.match(letters)){
            return true;
        } else {
            return false;
        }
    }

    createInfo(){
        if (this.allLetter(this.state.seller) === false){
            alert("Tên người bán không hợp lệ");
            return;
        }

        this.setState({ showNew: false });
        MaterialStockService.createMaterialStock({id: this.state.id, soCan: this.state.soCan, dungTich: this.state.dungTich, batchNoGroup: this.state.batchNo, selectedCode: this.state.selectedCode, stockDate: this.state.stockDate, seller: this.state.seller, canCode: 'C2' }).then(() => {
            this.onFilter()
        });
    }

    handleDelete(item){
        MaterialStockService.deleteMaterialStockByBatchNoGroup(item.batchNoGroup).then(() => {
            this.onFilter()
        });
    } 

    handleDeliverySelection(item){
        if (item.status !== MATERIAL_STOCK_STATUS_NEW){
            alert('Nguyên liệu đã được sử dụng');
            return;
        }

        // if (this.isSameDeliveryCode(item) === false){
        //     alert('Nguyên liệu xuất kho không cùng mã');
        //     return;
        // }
        

        let xkItem = {
            id: item.id,
            batchNo: item.batchNo,
            dungTich: item.dungTich,
            code: item.code
        };

        let xkItems = this.state.xkItems;
        xkItems.push(xkItem);
        
        //let ret = this.sumXuatKho(xkItems);
        //if (ret) {
        this.updateDeliveringStatus(item, xkItems);
        //}
    }

    updateDeliveringStatus(item, xkItems){
        let deliveringInfo = this.state.deliveringInfo;
        deliveringInfo[item.id + ""] = MATERIAL_STOCK_STATUS_DELIVERING;
        this.setState({ deliveringInfo: deliveringInfo, xkItems: xkItems });
    }

    handleDelivery(){
       
        //let ret = this.sumXuatKho(this.state.xkItems);
        //if (ret) {
            MaterialStockService.deliveryMaterialStock({ batchNoList: this.state.xkItems, canCode: this.state.selectedCanCode }).then(() => {
                this.setState({ xkItems: [], deliveringInfo: {} });
                this.onFilter()
            });
        //}
    } 

    isSameDeliveryCode(item){
        let xkItems = this.state.xkItems;
        if (xkItems === undefined || xkItems === null || xkItems.length <=0){
            return true;
        }

        for(let i=0; i<xkItems.length; i++){
            if (item.code === xkItems[i].code){
                return true;
            }
            return false;
        }
        return false;
    }

    isSelectedToDelivery(item){
        if (this.state.deliveringInfo["" + item.id] > 0){
            return true;
        }
        return false;
    }   

    sumXuatKho(xkItems){
        if (xkItems === undefined || xkItems === null){
            return true;
        }
        let sum = 0;
        for(let i=0; i<xkItems.length; i++){
            sum += xkItems[i].dungTich;
        }

        let selectedCan = undefined;
        for(let j=0; j<this.state.canItems.length; j++){
            if (this.state.selectedCanCode === this.state.canItems[j].code) {
                selectedCan = this.state.canItems[j];
                break;
            }
        }

        if (selectedCan === undefined){
            alert('Bạn phải chọn loại cốc');
            return false;
        }

        if (sum !== selectedCan.dungTich) {
            alert('Số lượng xuất kho không phù hợp với Loại cốc được chọn.');
            return false;
        }
        return true;

    }

    handleResetXk(){
        this.setState({ xkItems: [], deliveringInfo: {} });
    }  

    handleStockDateChange(date){
        var sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
        this.setState({                 
            stockDate: sDate                   
        }, () => {
            this.generatebatchNo();
        });
    } 

    handleFromDateChange(date){
        let sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
        this.setState({                 
        fromDate: sDate                   
        });
    }

    handleToDateChange(date){
        let sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
        this.setState({                 
        toDate: sDate                   
        });
    }

    handleHistoryFromDateChange(date){
        let sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
        this.setState({                 
            historyFromDate: sDate                   
        });
    }

    handleHistoryToDateChange(date){
        let sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
        this.setState({                 
            historyToDate: sDate                   
        });
    }

    handleProfileXiFromDateChange(date){
        let sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
        this.setState({                 
            profileXiFromDate: sDate                   
        });
    }

    handleProfileXiToDateChange(date){
        let sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
        this.setState({                 
            profileXiToDate: sDate                   
        });
    }
        

    handleSearchCodeChange(e){
        if (e.key === 'Enter') {
            this.onFilter()
            return;
        }    
        var value = e.target.value;
        this.setState({                 
            searchCode: value                   
        });
    }

    handleSearchMaterialChange(e){
        if (e.key === 'Enter') {
            this.onFilterHistory()
            return;
        }    
        var value = e.target.value;
        this.setState({                 
            searchMaterial: value                   
        });
    }

    handleSearchModifiedByChange(e){
        if (e.key === 'Enter') {
            this.onFilterHistory()
            return;
        }
        var value = e.target.value;
        this.setState({                 
            searchModifiedBy: value                   
        });
    }

    handleSearchSellerChange(e){
        if (e.key === 'Enter') {
            this.onFilter()
            return;
        }
        var value = e.target.value;
        this.setState({                 
            searchSeller: value                   
        });
    }

    handleKeyDown(e){
        if (e.key === 'Enter') {
            this.onFilter()
        }
    }

    onFilter() {
        this.setState({ page: 0, batchNoGroupInit: '' });
        this.filterBy();
    }

    onFilterHistory() {
        this.setState({ historyPage: 0 });
        this.filterHistoriesBy();
    }

    onFilterProfileXi() {
        this.setState({ selectedProfileXiPage: 0 });
        this.filterProfileXiBy();
    }    

    onStatusSelect(selectedList, selectedItem) {
        if (selectedItem.id === -1){
            this.handleSelectAllClick()
            return;
        }
        this.setState({
            selectedWoStatusList: selectedList
        });
    }
    
    onStatusRemove(selectedList, removedItem) {
        if (removedItem.id === -1){
            this.handleSelectAllClick()
            return;
        }
        
        this.setState({
            selectedWoStatusList: selectedList
        });   
    }

    handleSelectAllClick () {
        if (this.state.selectAll === '1'){
            this.setState({selectAll: '0', selectedWoStatusList: []});
        } else {
            let allStattus = this.state.statusList;
            this.setState({selectAll: '1', selectedWoStatusList: allStattus});
        }
    }

    sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    renderBatchNos(){
        if (this.state.batchNos === undefined || this.state.batchNos === null){
            return (<></>);
        }

        return (
            <>
            {
                this.state.batchNos.map((item, index) => {
                    return (
                        <div className="row" style={{ marginTop: "5px" }} key={'batchNo_' + index}>
                            <div className="col-1">&nbsp;</div>
                            <div className="col-10">
                                <div className="row">
                                    <div className="col-12">{item}</div>
                                </div>                  
                            </div>
                        </div>
                    );
                })
            }
            </>
        );
    }                 

    render(){
        if(!AuthenticationService.isAdmin() && !AuthenticationService.isSupervisor() && !AuthenticationService.isXi()){
            return (<div>Unauthorized access.</div>);
        }
        
        return (
            <div>

                <div className="row">
                    <div className="col-7">
                        <MaterialList key={this.state.refreshMaterial} />
                    </div>
                </div>
                <Modal show={this.state.show} onHide={this.handleClose.bind(this)} backdrop="static"  dialogClassName="modal-40w">
                  <Modal.Header closeButton>
                      <Modal.Title>Nhập nguyên liệu</Modal.Title>
                  </Modal.Header>
                  <Modal.Body> 
                        <div className="row">
                            <div className="col-6">
                                <span className="field_margin">{ couterpart.translate('material_stock_code') } : </span>
                            </div>                        
                            <div className="col-6">
                                { this.renderMaterialItemList() }
                            </div>
                        </div>                                                                                           
                        <div className="row" style={{ marginTop: "5px" }}>
                            <div className="col-6">
                                <span className="field_margin">{ couterpart.translate('material_stock_so_can') } : </span>
                            </div>                        
                            <div className="col-6">
                                <input type="text" name="soCan" defaultValue={this.state.soCan} onChange={this.handleSoCanChange.bind(this)}/>
                            </div>
                        </div>
                        <div className="row" style={{ marginTop: "5px" }}>
                            <div className="col-6">
                                <span className="field_margin">{ couterpart.translate('material_stock_dung_tich') } : </span>
                            </div>                        
                            <div className="col-6">
                                <input type="text" name="dungTich" defaultValue={this.state.dungTich} onChange={this.handleDungTichChange.bind(this)}/>
                            </div>
                        </div>
                        <div className="row" style={{ marginTop: "5px" }}>
                            <div className="col-6">
                                <span className="field_margin">{ couterpart.translate('material_stock_date') } : </span>
                            </div>                        
                            <div className="col-6">
                                <DatePicker name="stockDate"
                                    dateFormat="MM/dd/yyyy hh:mm"
                                    selected={ WorkOrderUtil.convertToDate(this.state.stockDate)}
                                    onChange={this.handleStockDateChange.bind(this)}/>
                            </div>
                        </div>
                        <div className="row" style={{ marginTop: "5px" }}>
                            <div className="col-6">
                                <span className="field_margin">{ couterpart.translate('material_stock_seller') } : </span>
                            </div>                        
                            <div className="col-6">
                                <input type="text" name="seller" defaultValue={this.state.seller} onChange={this.handleSellerChange.bind(this)}/>
                            </div>
                        </div>
                        <div className="row" style={{ marginTop: "5px" }}>
                            <div className="col-6">
                                <span className="field_margin">{ couterpart.translate('material_stock_batch_no') } : </span>
                            </div>                        
                            <div className="col-6">
                                { this.state.batchNo }
                            </div>
                        </div>
                        <div className="row" style={{ marginTop: "5px" }}>
                            <div className="col-6">
                                <span className="field_margin">{ couterpart.translate('material_stock_batch_nos') } : </span>
                            </div>                        
                            <div className="col-6">                               
                                <div className="row">
                                    <div className="col-12">
                                        { this.renderBatchNos() }
                                    </div>
                                </div>
                            </div>
                        </div>                      
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="primary" onClick={this.handleClose.bind(this)}>Cancel</Button>
                    <Button variant="primary" onClick={this.saveInfo.bind(this)}>OK</Button>  
                  </Modal.Footer>
                </Modal>
                
                <Modal show={this.state.showNew} onHide={this.handleCloseNew.bind(this)} backdrop="static"  dialogClassName="modal-60w">
                  <Modal.Header closeButton>
                      <Modal.Title>Nhập nguyên liệu</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                        <div className="row">
                            <div className="col-6">
                                <span className="field_margin">{ couterpart.translate('material_stock_code') } : </span>
                            </div>                        
                            <div className="col-6">
                                { this.renderMaterialItemList() }
                            </div>
                        </div>                                                                                           
                        <div className="row" style={{ marginTop: "5px" }}>
                            <div className="col-6">
                                <span className="field_margin">{ couterpart.translate('material_stock_so_can') } : </span>
                            </div>                        
                            <div className="col-6">
                                <input type="text" name="soCan" value={this.state.soCan} onChange={this.handleSoCanChange.bind(this)}/>
                            </div>
                        </div>
                        <div className="row" style={{ marginTop: "5px" }}>
                            <div className="col-6">
                                <span className="field_margin">{ couterpart.translate('material_stock_dung_tich') } : </span>
                            </div>                        
                            <div className="col-6">
                                <input type="text" name="dungTich" value={this.state.dungTich} onChange={this.handleDungTichChange.bind(this)}/>
                            </div>
                        </div>                        
                        <div className="row" style={{ marginTop: "5px" }}>
                            <div className="col-6">
                                <span className="field_margin">{ couterpart.translate('material_stock_date') } : </span>
                            </div>                        
                            <div className="col-6">
                                <DatePicker name="stockDate"
                                    dateFormat="MM/dd/yyyy hh:mm"
                                    selected={ WorkOrderUtil.convertToDate(this.state.stockDate)}
                                    onChange={this.handleStockDateChange.bind(this)}/>
                            </div>
                        </div>
                        <div className="row" style={{ marginTop: "5px" }}>
                            <div className="col-6">
                                <span className="field_margin">{ couterpart.translate('material_stock_seller') } : </span>
                            </div>                        
                            <div className="col-6">
                                <input type="text" name="seller" value={this.state.seller} onChange={this.handleSellerChange.bind(this)}/>
                            </div>
                        </div>
                        <div className="row" style={{ marginTop: "5px" }}>
                            <div className="col-6">
                                <span className="field_margin">{ couterpart.translate('material_stock_batch_no') } : </span>
                            </div>                        
                            <div className="col-6">
                                <div className="row">
                                    <div className="col-12">
                                        { this.state.batchNo }
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row" style={{ marginTop: "5px" }}>
                            <div className="col-6">
                                <span className="field_margin">{ couterpart.translate('material_stock_batch_nos') } : </span>
                            </div>                        
                            <div className="col-6">                               
                                <div className="row">
                                    <div className="col-12">
                                        { this.renderBatchNos() }
                                    </div>
                                </div>
                            </div>
                        </div>                     
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="primary" onClick={this.handleCloseNew.bind(this)}>Cancel</Button>
                    <Button variant="primary" onClick={this.createInfo.bind(this)}>OK</Button>  
                  </Modal.Footer>
                </Modal>

                <Modal show={this.state.showHistory} onHide={this.handleCloseHistories.bind(this)} backdrop="static"  dialogClassName="modal-90w">
                  <Modal.Header closeButton>
                      <Modal.Title>Lịch sử thay nguyên liệu</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                        <div className="row" style={{ margin: "20px"}}>
                            <div className="col-10">
                                <div className="row">
                                    <div className="col-12">
                                    <div className="row" style={{ margin: "2px"}}>
                                        <div className="col-5 border-top border-left border-right border-bottom border-light-gray" style={{ padding: '5px'}}>
                                            <div className="row">
                                                <div className="col-2">
                                                    <label><b>{couterpart.translate('order_date_from')}</b></label>
                                                </div>
                                                <div className="col-3">
                                                <div className="customDatePickerWidth">
                                                    <DatePicker name="historyDateFrom" 
                                                    dateFormat="MM/dd/yyyy hh:mm"              
                                                    selected={ WorkOrderUtil.convertToDate(this.state.historyFromDate)}
                                                    onChange={this.handleHistoryFromDateChange.bind(this)}/>
                                                </div>
                                                </div>
                                                <div className="col-2"><label><b>{couterpart.translate('order_date_to')}</b></label></div>
                                                <div className="col-3">
                                                <div className="customDatePickerWidth">
                                                    <DatePicker name="historyDateTo" 
                                                    dateFormat="MM/dd/yyyy hh:mm"
                                                    selected={ WorkOrderUtil.convertToDate(this.state.toDate)}
                                                    onChange={this.handleHistoryToDateChange.bind(this)}/>
                                                </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* <div className="col-4">
                                            <Multiselect style={{ width: "100%"}}
                                                options={this.state.statusList} 
                                                selectedValues={this.state.selectedWoStatusList} 
                                                onSelect={this.onStatusSelect.bind(this)} 
                                                onRemove={this.onStatusRemove.bind(this)} 
                                                displayValue="name"
                                                showCheckbox={true} 
                                            />
                                        </div> */}
                                        <div className="col-1">
                                            <input type="text" defaultValue={this.state.searchMaterial}  style={{ width: "100%", marginTop: "5px"}}
                                                placeholder={couterpart.translate('material_history_material_id')}
                                                onChange={this.handleSearchMaterialChange.bind(this)} onKeyDown = {(e) => { e.persist(); setTimeout(() => { this.handleSearchMaterialChange(e) }, 0); }}/>
                                        </div>
                                        <div className="col-1">
                                            <input type="text" defaultValue={this.state.searchModifiedBy}  style={{ width: "100%", marginTop: "5px"}}
                                                placeholder={couterpart.translate('material_history_modified_by')}
                                                onChange={this.handleSearchModifiedByChange.bind(this)} onKeyDown = {(e) => { e.persist(); setTimeout(() => { this.handleSearchModifiedByChange(e) }, 0); }}/>
                                        </div>                               
                                        <div className="col-1">
                                            <button className="myButton" 
                                                onClick={this.onFilterHistory.bind(this)}>
                                                <FaFilter color={ICON_COLOR}/>
                                                &nbsp;{couterpart.translate('button_filter')}
                                            </button>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                { this.renderMaterialHistoryList() }
                            </div>
                        </div>                     
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="primary" onClick={this.handleCloseHistories.bind(this)}>Cancel</Button>
                    <Button variant="primary" onClick={this.handleCloseHistories.bind(this)}>OK</Button>  
                  </Modal.Footer>
                </Modal>

                <Modal show={this.state.showInventory} onHide={this.handleCloseInventory.bind(this)} backdrop="static"  dialogClassName="modal-60w">
                  <Modal.Header closeButton>
                      <Modal.Title>Nguyên liệu tồn kho</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                        <div className="row">
                            <div className="col-12">
                                { this.renderInventory() }
                            </div>
                        </div>                     
                  </Modal.Body>
                  <Modal.Footer>
                    {/* <Button variant="primary" onClick={this.handleCloseInventory.bind(this)}>Cancel</Button> */}
                    <Button variant="primary" onClick={this.handleCloseInventory.bind(this)}>OK</Button>  
                  </Modal.Footer>
                </Modal>

                <Modal show={this.state.showMapping} onHide={this.handleCloseMapping.bind(this)} backdrop="static"  dialogClassName="modal-60w">
                  <Modal.Header closeButton>
                      <Modal.Title>Cài đặt nguyên liệu</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                        <div className="row">
                            <div className="col-6">
                                <span className="field_margin">{ couterpart.translate('material_stock_code') } : </span>
                            </div>                        
                            <div className="col-6">
                                { this.renderMappingMaterialItemList() }
                            </div>
                        </div>                                                                                           
                        <div className="row" style={{ marginTop: "5px" }}>
                            <div className="col-6">
                                <span className="field_margin">{ couterpart.translate('material_mapping_quantity') } : </span>
                            </div>                        
                            <div className="col-6">
                                <input type="text" name="mappingQuantity" value={this.state.mappingQuantity} onChange={this.handleMappingQuantityChange.bind(this)}/>
                            </div>
                        </div>
                        <div className="row" style={{ marginTop: "5px" }}>
                            <div className="col-6">
                                <span className="field_margin">{ couterpart.translate('material_mapping_can_code') } : </span>
                            </div>                        
                            <div className="col-6">
                                <input type="text" name="mappingCanCode" value={this.state.mappingCanCode} onChange={this.handleMappingCanCodeChange.bind(this)}/>
                            </div>
                        </div>                        
                        <div className="row" style={{ marginTop: "5px" }}>
                            <div className="col-6">
                                <span className="field_margin">{ couterpart.translate('material_mapping_can_capacity') } : </span>
                            </div>                        
                            <div className="col-6">
                                <input type="text" name="mappingCanCapacity" value={this.state.mappingCanCapacity} onChange={this.handleMappingCanCapacityChange.bind(this)}/>
                            </div>
                        </div>                   
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="primary" onClick={this.handleCloseMapping.bind(this)}>Cancel</Button>
                    <Button variant="primary" onClick={this.applyMapping.bind(this)}>Lưu lại</Button>
                    <Button variant="primary" onClick={this.saveAndCloseMapping.bind(this)}>OK</Button>  
                  </Modal.Footer>
                </Modal>

                <Modal show={this.state.showProfileXis} onHide={this.handleCloseProfileXis.bind(this)} backdrop="static"  dialogClassName="modal-90w">
                  <Modal.Header closeButton>
                      <Modal.Title>Profile Xi</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                        <div className="row" style={{ margin: "20px"}}>
                            <div className="col-10">
                                <div className="row">
                                    <div className="col-10">
                                        <div className="row" style={{ margin: "2px"}}>
                                            <div className="col-11 border-top border-left border-right border-bottom border-light-gray" style={{ padding: '5px'}}>
                                                <div className="row">
                                                    <div className="col-2">
                                                        <label><b>{couterpart.translate('order_date_from')}</b></label>
                                                    </div>
                                                    <div className="col-3">
                                                    <div className="customDatePickerWidth">
                                                        <DatePicker name="profileXiDateFrom" 
                                                        dateFormat="MM/dd/yyyy hh:mm"              
                                                        selected={ WorkOrderUtil.convertToDate(this.state.profileXiFromDate)}
                                                        onChange={this.handleProfileXiFromDateChange.bind(this)}/>
                                                    </div>
                                                    </div>
                                                    <div className="col-2"><label><b>{couterpart.translate('order_date_to')}</b></label></div>
                                                    <div className="col-3">
                                                    <div className="customDatePickerWidth">
                                                        <DatePicker name="profileXiDateTo" 
                                                        dateFormat="MM/dd/yyyy hh:mm"
                                                        selected={ WorkOrderUtil.convertToDate(this.state.profileXiToDate)}
                                                        onChange={this.handleProfileXiToDateChange.bind(this)}/>
                                                    </div>
                                                    </div>
                                                </div>
                                            </div>                             
                                            <div className="col-1">
                                                <button className="myButton" 
                                                    onClick={this.onFilterProfileXi.bind(this)}>
                                                    <FaFilter color={ICON_COLOR}/>
                                                    &nbsp;{couterpart.translate('button_filter')}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-2">
                                        <button className="myButton" 
                                            onClick={this.handleViewAddProfileXi.bind(this)}>
                                            <FaFolderPlus color={ICON_COLOR}/>
                                            &nbsp;{couterpart.translate('button_addProfile_xi')}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                { this.renderProfileXiList() }
                            </div>
                        </div>                     
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="primary" onClick={this.handleCloseProfileXis.bind(this)}>Cancel</Button>
                    <Button variant="primary" onClick={this.handleCloseProfileXis.bind(this)}>OK</Button>  
                  </Modal.Footer>
                </Modal>

                <Modal show={this.state.showAddProfileXi} onHide={this.handleCloseAddProfileXis.bind(this)} backdrop="static"  dialogClassName="modal-40w">
                  <Modal.Header closeButton>
                      <Modal.Title>Thêm profile xi</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                        <div className="row">
                            <div className="col-6">
                                <span className="field_margin">{ couterpart.translate('profile_xi_ten') } : </span>
                            </div>                        
                            <div className="col-6">
                                <input type="text" name="tenProfileXi" value={this.state.tenProfileXi} onChange={this.handleTenProfileXiChange.bind(this)}/>
                            </div>
                        </div>                                                                                           
                        <div className="row" style={{ marginTop: "5px" }}>
                            <div className="col-6">
                                <span className="field_margin">{ couterpart.translate('profile_xi_vol') } : </span>
                            </div>                        
                            <div className="col-6">
                                <input type="text" name="volProfileXi" value={this.state.volProfileXi} onChange={this.handleVolProfileXiChange.bind(this)}/>
                            </div>
                        </div>
                        <div className="row" style={{ marginTop: "5px" }}>
                            <div className="col-6">
                                <span className="field_margin">{ couterpart.translate('profile_xi_nhietdo') } : </span>
                            </div>                        
                            <div className="col-6">
                                <input type="text" name="nhietDoProfileXi" value={this.state.nhietDoProfileXi} onChange={this.handleNhietDoProfileXiChange.bind(this)}/>
                            </div>
                        </div>                        
                        <div className="row" style={{ marginTop: "5px" }}>
                            <div className="col-6">
                                <span className="field_margin">{ couterpart.translate('profile_xi_thoigian') } : </span>
                            </div>                        
                            <div className="col-6">
                                <input type="text" name="thoiGianProfileXi" value={this.state.thoiGianProfileXi} onChange={this.handleThoiGianProfileXiChange.bind(this)}/>
                            </div>
                        </div>
                        <div className="row" style={{ marginTop: "5px" }}>
                            <div className="col-6">
                                <span className="field_margin">{ couterpart.translate('profile_xi_ph') } : </span>
                            </div>                        
                            <div className="col-6">
                                <input type="text" name="phProfileXi" value={this.state.phProfileXi} onChange={this.handlePhProfileXiChange.bind(this)}/>
                            </div>
                        </div>
                        <div className="row" style={{ marginTop: "5px" }}>
                            <div className="col-6">
                                <span className="field_margin">{ couterpart.translate('profile_xi_tytrong') } : </span>
                            </div>                        
                            <div className="col-6">
                                <input type="text" name="tyTrongProfileXi" value={this.state.tyTrongProfileXi} onChange={this.handleTyTrongProfileXiChange.bind(this)}/>
                            </div>
                        </div>
                        <div className="row" style={{ marginTop: "5px" }}>
                            <div className="col-6">
                                <span className="field_margin">{ couterpart.translate('profile_xi_group') } : </span>
                            </div>                        
                            <div className="col-6">
                                <input type="text" name="groupNameProfileXi" value={this.state.groupNameProfileXi} onChange={this.handleGroupNameProfileXiChange.bind(this)}/>
                            </div>
                        </div>
                        <div className="row" style={{ marginTop: "5px" }}>
                            <div className="col-6">
                                <span className="field_margin">{ couterpart.translate('profile_xi_note') } : </span>
                            </div>                        
                            <div className="col-6">
                                <input type="text" name="noteProfileXi" value={this.state.noteProfileXi} onChange={this.handleNoteProfileXiChange.bind(this)}/>
                            </div>
                        </div>                                                                   
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="primary" onClick={this.handleCloseAddProfileXis.bind(this)}>Cancel</Button>
                    <Button variant="primary" onClick={this.saveProfileXi.bind(this)}>Lưu lại</Button>
                    <Button variant="primary" onClick={this.saveAndCloseAddProfileXis.bind(this)}>OK</Button>  
                  </Modal.Footer>
                </Modal>

                <Modal show={this.state.showMappingProfile} onHide={this.handleCloseMappingProfile.bind(this)} backdrop="static"  dialogClassName="modal-40w">
                  <Modal.Header closeButton>
                      <Modal.Title>Cài đặt profile xi cho nguyên liệu</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                        <div className="row">
                            <div className="col-6">
                                <span className="field_margin">{ couterpart.translate('material_profile_material_code') } : </span>
                            </div>                        
                            <div className="col-6">
                                { this.renderMappingMaterialProfileItemList() }
                            </div>
                        </div>
                        <div className="row" style={{ marginTop: "10px"}}>
                            <div className="col-6">
                                <span className="field_margin">{ couterpart.translate('material_profile_profile_id') } : </span>
                            </div>                        
                            <div className="col-6">
                                { this.renderMappingProfileXiItemList() }
                            </div>
                        </div>                                                                                                             
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="primary" onClick={this.handleCloseMappingProfile.bind(this)}>Cancel</Button>
                    <Button variant="primary" onClick={this.applyMappingProfile.bind(this)}>Lưu lại</Button>
                    <Button variant="primary" onClick={this.saveAndCloseMappingProfile.bind(this)}>OK</Button>  
                  </Modal.Footer>
                </Modal>

                <Spinner size={25} spinnerColor={ICON_COLOR} spinnerWidth={2} visible={this.state.spinnerVisible} />
            </div>
        );
    }
}

export default MaterialStockTabSuper;
